import { render, staticRenderFns } from "./SideCongressEmpty.vue?vue&type=template&id=4bccd3d7&scoped=true"
import script from "./SideCongressEmpty.vue?vue&type=script&lang=js"
export * from "./SideCongressEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bccd3d7",
  null
  
)

export default component.exports